var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[ _vm._isMobile() ? 'mobile' : '','courseLayout']},[_c('Header',{attrs:{"id":"header"}}),_c('div',{staticClass:"cms"},[_c('router-view')],1),_c('a-back-top')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }